import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HomeService } from 'src/app/services/home.service';

@Component({
  selector: 'app-collaborators-details',
  templateUrl: './collaborators-details.component.html',
  styleUrls: ['./collaborators-details.component.css']
})
export class CollaboratorsDetailsComponent implements OnInit {
  id:any
  CollaboratorName:string = ''
  CollaboratorDsc:string = ''
  CollaboratorImage:string= ''
  CollaboratorDetails:string = ''
  CollaboratorPhone:string = ''
  load:boolean=false
  googlescholer: any
  linkedin: any
  publons: any
  email:any

  constructor(private _Activatedroute: ActivatedRoute,private homeService_: HomeService) { }

  ngOnInit(): void {
    this.load = false
    this.id = this._Activatedroute.snapshot.paramMap.get("id")

    this.homeService_.getPost('getPostById',this.id, 'en', '', 'Collaborators', '', '', '1').subscribe(data => {
      let arr = data as any[]
      this.CollaboratorName = arr[0]['postTitle']
      this.CollaboratorDsc = arr[0]['postSubTitle']
      this.CollaboratorImage = arr[0]['postImage']
      this.CollaboratorDetails = arr[0]['postDetails']
      this.googlescholer=arr[0]['collaborators_GoogleSchoolar']
      this.linkedin=arr[0]['collaborators_Linkedin']
      this.publons=arr[0]['collaborators_Publons']
      this.email=arr[0]['collaborators_Email']
         this.load = true
    });
  }


}
